import { Box, Typography as T } from "@mui/material";

const DirectoryHeader = () => (
  <T
    component={Box}
    variant="label"
    display="flex"
    gap={4}
    px={2.5}
    py={1.5}
    fontSize={13}
    fontWeight={500}
    borderBottom={1}
    borderColor="grey.300"
  >
    <Box sx={{ flex: 1, textWrap: "nowrap" }}>Name</Box>
    <Box width={100} textAlign="end">
      Size
    </Box>
    <Box width={236}>Updated</Box>
  </T>
);

export default DirectoryHeader;
